'use strict';

// Constructor
export class Sidebar {
    constructor() {
        $('.layout-content.has_sidebar .menu-item--expanded').each(function (i, menuitem) {
            var $menuitem = $(menuitem);
            var expander = "<a href='#expander' class='expander'></a>";
            $menuitem.append(expander);
        })

        $('.layout-content.has_sidebar').on('click', '.expander', function (e) {
            e.preventDefault();
            $(this).parents('.menu-item--expanded').toggleClass('expanded');
            if ($(this).siblings('.menu_link_content').length > 0) {
                $(this).siblings('.menu_link_content').find('ul').slideToggle();
            } else {
                $(this).siblings('ul').slideToggle();
            }
        })
    }
}